// Job Complete & Review Request Email Generator for HomeGo Removals
// Enhanced with warm, engaging elements - tips, referral, social media

const generateJobCompleteEmailHTML = (data) => {
  const {
    customer_name = "John Smith",
    moving_from = "MK11 4BB",
    moving_to = "MK14 7BB",
    move_date = "",
    quotation_reference = "HG-00001",
    google_review_link = "",
    trustpilot_link = "",
    consultant_name = "Thomas Jacobs",
    consultant_title = "Customer Consultant",
    company_phone = "0330 043 4791",
    company_email = "office@homego-removals.com",
    custom_message = "",
  } = data;

  const firstName = customer_name.split(' ')[0];
  
  // Generate review buttons HTML
  const googleButton = google_review_link ? `
    <tr>
      <td align="center" style="padding: 8px 0;">
        <a href="${google_review_link}" target="_blank" style="display: inline-block; background: linear-gradient(135deg, #4285F4 0%, #356ac3 100%); color: #FFFFFF; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; text-decoration: none; padding: 14px 35px; border-radius: 30px; box-shadow: 0 4px 15px rgba(66, 133, 244, 0.3);">
          ⭐ Leave a Google Review
        </a>
      </td>
    </tr>
  ` : '';

  const trustpilotButton = trustpilot_link ? `
    <tr>
      <td align="center" style="padding: 8px 0;">
        <a href="${trustpilot_link}" target="_blank" style="display: inline-block; background: linear-gradient(135deg, #00B67A 0%, #008f5f 100%); color: #FFFFFF; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; text-decoration: none; padding: 14px 35px; border-radius: 30px; box-shadow: 0 4px 15px rgba(0, 182, 122, 0.3);">
          ⭐ Review us on Trustpilot
        </a>
      </td>
    </tr>
  ` : '';

  const hasReviewLinks = google_review_link || trustpilot_link;

  return `
<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml">
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Welcome to Your New Home - HomeGo Removals</title>
  <style type="text/css">
    @media only screen and (max-width: 620px) {
      .email-container { width: 100% !important; }
      .mobile-padding { padding-left: 15px !important; padding-right: 15px !important; }
      .mobile-center { text-align: center !important; }
      .tip-box { display: block !important; width: 100% !important; margin-bottom: 10px !important; }
    }
  </style>
</head>
<body style="margin: 0; padding: 0; background-color: #F4F4F5; font-family: Helvetica, Arial, sans-serif;">
  
  <!-- Preheader -->
  <div style="display: none; max-height: 0; overflow: hidden;">
    Congratulations on your move! We hope you're settling in well at your new home. Your feedback means the world to us!
  </div>
  
  <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #F4F4F5;">
    <tr>
      <td align="center" style="padding: 20px 10px;">
        <table class="email-container" border="0" cellpadding="0" cellspacing="0" width="600" style="max-width: 600px; width: 100%; background-color: #FFFFFF; border-radius: 16px; overflow: hidden; box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);">
          
          <!-- Header with Logo -->
          <tr>
            <td style="background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%); padding: 30px 40px; text-align: center;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td align="center">
                    <h1 style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 32px; font-weight: bold; color: #FFFFFF; letter-spacing: 1px;">
                      Home<span style="color: #D4AF37;">Go</span>
                    </h1>
                    <p style="margin: 5px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #888; letter-spacing: 2px; text-transform: uppercase;">
                      REMOVALS & PACKING LTD
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Celebration Banner with Animation Feel -->
          <tr>
            <td style="background: linear-gradient(135deg, #D4AF37 0%, #f4d03f 50%, #D4AF37 100%); padding: 35px 40px; text-align: center;">
              <p style="margin: 0; font-size: 60px; line-height: 1;">🏠✨</p>
              <h2 style="margin: 15px 0 8px; font-family: Georgia, serif; font-size: 28px; font-weight: bold; color: #1a1a1a;">
                Welcome to Your New Home!
              </h2>
              <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 15px; color: #333;">
                Your move is complete - time to make beautiful memories!
              </p>
            </td>
          </tr>

          <!-- Completion Badge -->
          <tr>
            <td align="center" style="padding: 25px 40px 0;">
              <table border="0" cellpadding="0" cellspacing="0" style="background: linear-gradient(135deg, #10B981 0%, #059669 100%); border-radius: 50px; box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3);">
                <tr>
                  <td style="padding: 12px 30px;">
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; color: #FFFFFF; letter-spacing: 1px;">
                      ✓ MOVE COMPLETED SUCCESSFULLY
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Personal Message -->
          <tr>
            <td style="padding: 30px 40px;">
              <p style="margin: 0 0 20px; font-family: Helvetica, Arial, sans-serif; font-size: 17px; color: #333; line-height: 1.6;">
                Dear <strong style="color: #D4AF37;">${firstName}</strong>,
              </p>
              
              <p style="margin: 0 0 20px; font-family: Helvetica, Arial, sans-serif; font-size: 15px; color: #555; line-height: 1.8;">
                We hope this message finds you settling in comfortably at your new address in <strong style="color: #D4AF37;">${moving_to}</strong>! 
                Moving home is one of life's biggest adventures, and we were truly honoured to be part of your journey.
              </p>

              <p style="margin: 0 0 20px; font-family: Helvetica, Arial, sans-serif; font-size: 15px; color: #555; line-height: 1.8;">
                From <strong>${moving_from}</strong> to your beautiful new place - we hope everything arrived safely and you're already enjoying your fresh start. 
                ${custom_message ? custom_message : "May your new home bring you endless joy, comfort, and countless happy moments with your loved ones."}
              </p>
            </td>
          </tr>

          <!-- Move Details Card -->
          <tr>
            <td style="padding: 0 40px 25px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%); border-radius: 12px; border: 1px solid #e9ecef;">
                <tr>
                  <td style="padding: 20px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td style="padding-bottom: 15px; border-bottom: 2px solid #D4AF37;">
                          <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 13px; color: #D4AF37; text-transform: uppercase; letter-spacing: 2px; font-weight: bold;">
                            📦 Your Move Summary
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="padding-top: 18px;">
                          <table border="0" cellpadding="0" cellspacing="0" width="100%">
                            <tr>
                              <td width="48%" style="vertical-align: top;">
                                <p style="margin: 0 0 4px; font-family: Helvetica, Arial, sans-serif; font-size: 10px; color: #888; text-transform: uppercase; letter-spacing: 1px;">FROM</p>
                                <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 16px; color: #333; font-weight: bold;">${moving_from}</p>
                              </td>
                              <td width="4%" style="vertical-align: middle; text-align: center;">
                                <p style="margin: 0; font-size: 20px; color: #D4AF37;">→</p>
                              </td>
                              <td width="48%" style="vertical-align: top;">
                                <p style="margin: 0 0 4px; font-family: Helvetica, Arial, sans-serif; font-size: 10px; color: #888; text-transform: uppercase; letter-spacing: 1px;">TO</p>
                                <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 16px; color: #10B981; font-weight: bold;">${moving_to}</p>
                              </td>
                            </tr>
                            ${move_date ? `
                            <tr>
                              <td colspan="3" style="padding-top: 15px;">
                                <p style="margin: 0 0 4px; font-family: Helvetica, Arial, sans-serif; font-size: 10px; color: #888; text-transform: uppercase; letter-spacing: 1px;">MOVE DATE</p>
                                <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333;">${move_date}</p>
                              </td>
                            </tr>
                            ` : ''}
                            <tr>
                              <td colspan="3" style="padding-top: 15px;">
                                <p style="margin: 0 0 4px; font-family: Helvetica, Arial, sans-serif; font-size: 10px; color: #888; text-transform: uppercase; letter-spacing: 1px;">REFERENCE</p>
                                <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333;">${quotation_reference}</p>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Thank You Message -->
          <tr>
            <td style="padding: 0 40px 25px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: linear-gradient(135deg, #fef3c7 0%, #fff 100%); border-radius: 12px; border-left: 4px solid #D4AF37;">
                <tr>
                  <td style="padding: 20px;">
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 15px; color: #555; line-height: 1.7;">
                      <strong style="color: #1a1a1a;">Thank you</strong> for trusting HomeGo Removals with your move. 
                      Your satisfaction means everything to us, and we truly appreciate you choosing our team to help you start this exciting new chapter! 💛
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          ${hasReviewLinks ? `
          <!-- Review Request Section -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: linear-gradient(135deg, #fffbeb 0%, #fff 100%); border: 2px solid #D4AF37; border-radius: 16px; overflow: hidden;">
                <tr>
                  <td style="background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%); padding: 15px; text-align: center;">
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #D4AF37; font-weight: bold; letter-spacing: 1px;">
                      ⭐ YOUR FEEDBACK MATTERS ⭐
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style="padding: 25px; text-align: center;">
                    <p style="margin: 0; font-size: 35px;">⭐⭐⭐⭐⭐</p>
                    <h3 style="margin: 15px 0 10px; font-family: Georgia, serif; font-size: 22px; color: #1a1a1a;">
                      How Did We Do?
                    </h3>
                    <p style="margin: 0 0 25px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #666; line-height: 1.6;">
                      Your feedback helps us improve and helps other families<br/>find reliable movers. It only takes a minute!
                    </p>
                    
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      ${googleButton}
                      ${trustpilotButton}
                    </table>
                    
                    <p style="margin: 20px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #888;">
                      Your kind words mean the world to our team! 🙏
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          ` : ''}

          <!-- New Home Tips Section -->
          <tr>
            <td style="padding: 0 40px 25px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: linear-gradient(135deg, #f0fdf4 0%, #fff 100%); border-radius: 12px; border: 1px solid #bbf7d0;">
                <tr>
                  <td style="padding: 20px;">
                    <p style="margin: 0 0 15px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #166534; font-weight: bold; text-transform: uppercase; letter-spacing: 1px;">
                      💡 Tips for Your New Home
                    </p>
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td class="tip-box" width="48%" style="vertical-align: top; padding: 10px; background: #fff; border-radius: 8px; margin-right: 4%;">
                          <p style="margin: 0 0 5px; font-size: 18px;">📍</p>
                          <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #333; font-weight: bold;">Update Your Address</p>
                          <p style="margin: 3px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 11px; color: #666;">Banks, DVLA, subscriptions</p>
                        </td>
                        <td width="4%"></td>
                        <td class="tip-box" width="48%" style="vertical-align: top; padding: 10px; background: #fff; border-radius: 8px;">
                          <p style="margin: 0 0 5px; font-size: 18px;">🔑</p>
                          <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #333; font-weight: bold;">Change the Locks</p>
                          <p style="margin: 3px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 11px; color: #666;">For peace of mind</p>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3" style="height: 10px;"></td>
                      </tr>
                      <tr>
                        <td class="tip-box" width="48%" style="vertical-align: top; padding: 10px; background: #fff; border-radius: 8px;">
                          <p style="margin: 0 0 5px; font-size: 18px;">👋</p>
                          <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #333; font-weight: bold;">Meet the Neighbours</p>
                          <p style="margin: 3px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 11px; color: #666;">A friendly hello goes far</p>
                        </td>
                        <td width="4%"></td>
                        <td class="tip-box" width="48%" style="vertical-align: top; padding: 10px; background: #fff; border-radius: 8px;">
                          <p style="margin: 0 0 5px; font-size: 18px;">📸</p>
                          <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #333; font-weight: bold;">Take Photos</p>
                          <p style="margin: 3px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 11px; color: #666;">Document meter readings</p>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Referral Program Section -->
          <tr>
            <td style="padding: 0 40px 25px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%); border-radius: 12px; overflow: hidden;">
                <tr>
                  <td style="padding: 25px; text-align: center;">
                    <p style="margin: 0 0 5px; font-size: 30px;">🎁</p>
                    <h3 style="margin: 0 0 10px; font-family: Helvetica, Arial, sans-serif; font-size: 18px; color: #FFFFFF; font-weight: bold;">
                      Share the Love, Save £25!
                    </h3>
                    <p style="margin: 0 0 15px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: rgba(255,255,255,0.9); line-height: 1.5;">
                      Know someone planning a move? Refer them to us and<br/>
                      <strong>both of you get £25 off!</strong>
                    </p>
                    <table border="0" cellpadding="0" cellspacing="0" align="center">
                      <tr>
                        <td style="background: #FFFFFF; border-radius: 25px; padding: 12px 30px;">
                          <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 13px; color: #7C3AED; font-weight: bold;">
                            Your Referral Code: <span style="color: #1a1a1a;">${quotation_reference}</span>
                          </p>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Need Help Section -->
          <tr>
            <td style="padding: 0 40px 25px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: #f8fafc; border-radius: 12px; border: 1px dashed #cbd5e1;">
                <tr>
                  <td style="padding: 20px; text-align: center;">
                    <p style="margin: 0 0 5px; font-size: 24px;">🛠️</p>
                    <p style="margin: 0 0 8px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333; font-weight: bold;">
                      Need Help Settling In?
                    </p>
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 13px; color: #666; line-height: 1.5;">
                      If anything wasn't quite right or you need assistance,<br/>
                      please don't hesitate to contact us. We're here to help!
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Consultant Signature -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td style="vertical-align: top; padding-right: 15px;" width="65">
                    <div style="width: 60px; height: 60px; background: linear-gradient(135deg, #D4AF37 0%, #f4d03f 100%); border-radius: 50%; text-align: center; line-height: 60px;">
                      <span style="font-size: 28px;">👋</span>
                    </div>
                  </td>
                  <td style="vertical-align: middle;">
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333;">
                      Wishing you all the best in your new home,
                    </p>
                    <p style="margin: 5px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 18px; color: #1a1a1a; font-weight: bold;">
                      ${consultant_name}
                      <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/Twitter_Verified_Badge.svg/20px-Twitter_Verified_Badge.svg.png" alt="Verified" width="16" height="16" style="vertical-align: middle; margin-left: 5px;" />
                    </p>
                    <p style="margin: 3px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #888;">
                      ${consultant_title} | HomeGo Removals & Packing Ltd
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Social Media Section -->
          <tr>
            <td style="background: #f8fafc; padding: 25px 40px; text-align: center; border-top: 1px solid #e2e8f0;">
              <p style="margin: 0 0 15px; font-family: Helvetica, Arial, sans-serif; font-size: 13px; color: #64748b; font-weight: bold; text-transform: uppercase; letter-spacing: 1px;">
                Stay Connected
              </p>
              <table border="0" cellpadding="0" cellspacing="0" align="center">
                <tr>
                  <td style="padding: 0 8px;">
                    <a href="https://facebook.com/homegoremovals" target="_blank" style="display: inline-block; width: 40px; height: 40px; background: #1877F2; border-radius: 50%; text-align: center; line-height: 40px; text-decoration: none;">
                      <img src="https://cdn-icons-png.flaticon.com/24/733/733547.png" alt="Facebook" width="20" height="20" style="vertical-align: middle;" />
                    </a>
                  </td>
                  <td style="padding: 0 8px;">
                    <a href="https://instagram.com/homegoremovals" target="_blank" style="display: inline-block; width: 40px; height: 40px; background: linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%); border-radius: 50%; text-align: center; line-height: 40px; text-decoration: none;">
                      <img src="https://cdn-icons-png.flaticon.com/24/733/733558.png" alt="Instagram" width="20" height="20" style="vertical-align: middle;" />
                    </a>
                  </td>
                  <td style="padding: 0 8px;">
                    <a href="https://wa.me/447440414548" target="_blank" style="display: inline-block; width: 40px; height: 40px; background: #25D366; border-radius: 50%; text-align: center; line-height: 40px; text-decoration: none;">
                      <img src="https://cdn-icons-png.flaticon.com/24/733/733585.png" alt="WhatsApp" width="20" height="20" style="vertical-align: middle;" />
                    </a>
                  </td>
                </tr>
              </table>
              <p style="margin: 15px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #94a3b8;">
                Tag us in your new home photos! 📸 #HomeGoRemovals
              </p>
            </td>
          </tr>



          <!-- Footer -->
          <tr>
            <td style="background: linear-gradient(135deg, #1a1a1a 0%, #0f0f0f 100%); padding: 30px 40px; text-align: center;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <!-- Contact Buttons -->
                <tr>
                  <td align="center" style="padding-bottom: 20px;">
                    <table border="0" cellpadding="0" cellspacing="0">
                      <tr>
                        <td style="padding: 0 6px;">
                          <a href="https://wa.me/447440414548" style="display: inline-block; background: #25D366; color: #FFFFFF; font-family: Helvetica, Arial, sans-serif; font-size: 12px; font-weight: bold; text-decoration: none; padding: 10px 20px; border-radius: 25px;">
                            💬 WhatsApp
                          </a>
                        </td>
                        <td style="padding: 0 6px;">
                          <a href="tel:${company_phone.replace(/\s/g, '')}" style="display: inline-block; background: #D4AF37; color: #000000; font-family: Helvetica, Arial, sans-serif; font-size: 12px; font-weight: bold; text-decoration: none; padding: 10px 20px; border-radius: 25px;">
                            📞 Call Us
                          </a>
                        </td>
                        <td style="padding: 0 6px;">
                          <a href="mailto:${company_email}" style="display: inline-block; background: #3B82F6; color: #FFFFFF; font-family: Helvetica, Arial, sans-serif; font-size: 12px; font-weight: bold; text-decoration: none; padding: 10px 20px; border-radius: 25px;">
                            ✉️ Email
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td align="center">
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #FFFFFF;">
                      Registered in England & Wales | Company No: <span style="color: #D4AF37;">16811153</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td align="center" style="padding-top: 8px;">
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 11px; color: #888;">
                      HomeGo Removals & Packing Ltd | UK's Nationwide Premium Moving Company | ${company_phone}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td align="center" style="padding-top: 15px;">
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 10px; color: #555;">
                      © HomeGo Removals & Packing Ltd. All rights reserved.<br/>
                      You received this as a valued customer. Reply "unsubscribe" to opt out.
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

        </table>
      </td>
    </tr>
  </table>
</body>
</html>
`;
};

export default generateJobCompleteEmailHTML;
